import { useTranslation } from 'react-i18next';
import { MapPin } from 'lucide-react';
import { GuideSection } from '../components/GuideSection';
import { GuideSubSection } from '../components/GuideSubSection';
import { RoleHint } from '../components/RoleHint';

export function AddressInformationSection() {
  const { t } = useTranslation('help');
  const s = 'sections.addressInformation';

  return (
    <GuideSection
      id="address-information"
      title={t(`${s}.title`)}
      description={t(`${s}.description`)}
      icon={MapPin}
    >
      <GuideSubSection title={t(`${s}.search.title`)}>
        <p>{t(`${s}.search.p1`)}</p>
        <p>{t(`${s}.search.p2`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.sections.title`)}>
        <p>{t(`${s}.sections.p1`)}</p>
        <p>{t(`${s}.sections.p2`)}</p>
        <RoleHint variant="external">{t(`${s}.sections.externalHint`)}</RoleHint>
      </GuideSubSection>
    </GuideSection>
  );
}
